/**
 * Maneuver type/modifier → an arrow. Mapbox names these; we only draw them.
 *
 * ⚠️ `EnRouteMap.jsx` carries an IDENTICAL private copy. This is the shared extraction,
 * used by the manifest map; pointing the en-route map here too is a two-line change and
 * was left out of the manifest work so that screen was not touched by it.
 *
 * @param {string} type      Directions' `maneuver.type` — `turn`, `arrive`, `merge`, …
 * @param {string} modifier  Directions' `maneuver.modifier` — `left`, `slight right`, …
 */
export default function ManeuverArrow({type, modifier}) {
    const rotate = {
        left: -90, right: 90, 'slight left': -45, 'slight right': 45,
        'sharp left': -135, 'sharp right': 135, uturn: 180, straight: 0,
    }[modifier] ?? 0

    // `arrive` is not a turn — it is the end, and an arrow would imply another junction.
    if (type === 'arrive') {
        return (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                <circle cx="12" cy="12" r="4"/>
                <circle cx="12" cy="12" r="9" opacity="0.35"/>
            </svg>
        )
    }

    return (
        <svg
            width="26" height="26" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"
            style={{transform: `rotate(${rotate}deg)`}}
        >
            <path d="M12 21V6"/>
            <path d="M6 11l6-6 6 6"/>
        </svg>
    )
}

export {ManeuverArrow}
